import { OPEN_TOPO_MAP_SOURCE } from 'constants/map';
import { RasterSourceSpecification } from 'mapbox-gl';

export const openTopoMapSource: RasterSourceSpecification = {
  id: OPEN_TOPO_MAP_SOURCE,
  type: 'raster',
  tiles: [
    'https://a.tile.opentopomap.org/{z}/{x}/{y}.png',
    'https://b.tile.opentopomap.org/{z}/{x}/{y}.png',
    'https://c.tile.opentopomap.org/{z}/{x}/{y}.png',
  ],
  maxzoom: 15,
  minzoom: 1,
  tileSize: 256,
};
